import { createActionGroup, props } from '@ngrx/store';
import { Flag } from './types';

export const FeatureFlagsAction = createActionGroup({
  source: 'Feature Flags',
  events: {
    Loaded: props<{ flags: { [key: string]: Flag } }>(),
  },
});
